import { Truck, Percent, Clock } from "lucide-react";
import { FREE_SHIPPING_THRESHOLD, WHOLESALE_TIERS } from "@/lib/promos";
import { formatARS } from "@/lib/api";

const PromoBanner = () => {
  const top = WHOLESALE_TIERS[0];
  const second = WHOLESALE_TIERS[1];
  const items = [
    { icon: Truck, color: "bg-green-600", title: "Envío gratis", text: <>desde <strong>{formatARS(FREE_SHIPPING_THRESHOLD)}</strong></> },
    { icon: Percent, color: "bg-blue-600", title: "Mayoristas", text: <><strong>{Math.round(second.discount * 100)}% OFF</strong> desde {formatARS(second.threshold)} · <strong>{Math.round(top.discount * 100)}% OFF</strong> desde {formatARS(top.threshold)}</> },
    { icon: Clock, color: "bg-red-500", title: "Pedidos 24/7", text: <>respuesta inmediata por WhatsApp</> },
  ];

  return (
    <section className="bg-slate-50 border-b border-slate-200" data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-6 text-xs sm:text-sm">
        {items.map((it) => (
          <div key={it.title} className="flex items-center gap-2.5 min-w-0">
            <span className={`w-7 h-7 rounded-full ${it.color} text-white flex items-center justify-center flex-shrink-0`}><it.icon className="w-3.5 h-3.5" /></span>
            <span className="text-slate-600 leading-snug"><span className="font-semibold text-slate-900">{it.title}</span> · {it.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PromoBanner;
